export default __webpack_public_path__ + "static/media/Charlie Stedman Resume.c2ddc6f9.pdf";